'use client';

import { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface Post {
    id: string;
    title: string;
    url: string;
}

interface Category {
    category: string | null;
    posts: Post[];
}

interface BlogSidebarProps {
    categoriesWithPosts: Category[];
}

export default function BlogSidebar({ categoriesWithPosts }: BlogSidebarProps) {
    const [isOpen, setIsOpen] = useState(false);
    const pathname = usePathname();

    return (
        <aside className="w-full md:w-64 border-b md:border-b-0 md:border-r p-4">
            {/* Hamburger Menu Button */}
            <button
                className="block md:hidden p-4"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Toggle Menu"
            >
                <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h16M4 12h16m-7 6h7"
                    ></path>
                </svg>
            </button>

            <nav
                className={`${
                    isOpen ? 'block' : 'hidden'
                } md:block h-full p-4`}
            >
                <ul>
                    {categoriesWithPosts.map(({ category, posts }) => (
                        <li key={category || 'root'}>
                            <Link href={`/blog/posts/${category}`}>
                                <h2 className="font-semibold">{category || 'Uncategorized'}</h2>
                            </Link>
                            <ul className="pl-4">
                                {posts.map((post) => (
                                    <li key={post.id} className={`font-semibold p-4 ${
                                        pathname === `/${post.url}` ? 'text-yellow-500 underline' : ''
                                    }`}>
                                        <Link href={`/${post.url}`}>
                                            {post.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    );
}
